var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComment = function SvgComment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.997c0 3.93 2.995 7 7 7 1 0 1.105.552 1 1-.281 1.035-.832 2.07-1.5 3-.351.483-.097 1.07.5 1 2.53-.241 7.054-1.177 8.178-4.624.106-.276.322-.376.822-.376h3c5 0 7-3 7-7v-3c0-3.93-2.727-7-7-7H7c-4 0-7 3.07-7 7v3Z",
    fill: "currentColor"
  })));
};
export default SvgComment;